const SearchIcon = () => {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="21" height="21" transform="translate(0 0.888916)" fill="#002C4E" />
      <mask
        id="mask0_62_2426"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="22"
      >
        <rect y="0.888916" width="21" height="21" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_62_2426)">
        <path
          d="M17.15 19.2639L11.6375 13.7514C11.2 14.1014 10.6969 14.3785 10.1281 14.5827C9.55937 14.7868 8.95417 14.8889 8.3125 14.8889C6.72292 14.8889 5.3776 14.3384 4.27656 13.2374C3.17552 12.1363 2.625 10.791 2.625 9.20142C2.625 7.61183 3.17552 6.26652 4.27656 5.16548C5.3776 4.06444 6.72292 3.51392 8.3125 3.51392C9.90208 3.51392 11.2474 4.06444 12.3484 5.16548C13.4495 6.26652 14 7.61183 14 9.20142C14 9.84308 13.8979 10.4483 13.6938 11.017C13.4896 11.5858 13.2125 12.0889 12.8625 12.5264L18.375 18.0389L17.15 19.2639ZM8.3125 13.1389C9.40625 13.1389 10.3359 12.7561 11.1016 11.9905C11.8672 11.2249 12.25 10.2952 12.25 9.20142C12.25 8.10767 11.8672 7.17798 11.1016 6.41235C10.3359 5.64673 9.40625 5.26392 8.3125 5.26392C7.21875 5.26392 6.28906 5.64673 5.52344 6.41235C4.75781 7.17798 4.375 8.10767 4.375 9.20142C4.375 10.2952 4.75781 11.2249 5.52344 11.9905C6.28906 12.7561 7.21875 13.1389 8.3125 13.1389Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
